.pagination .page-item{cursor:pointer}
/*# sourceMappingURL=pagination.component-VJUUDJP3.css.map */
